import {Alert} from 'platform/components';
import {Box} from 'platform/foundation';

import {useGetSupportedPlatformsQuery} from '@dms/api/core';
import {useGetPlatformsQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';

export function UnsuportedPlatformsNotification() {
  const {data: supportedPlatforms} = useGetSupportedPlatformsQuery();
  const {data: platforms = []} = useGetPlatformsQuery({});

  const unsuportedPlatforms = platforms
    .reduce((memo: string[], platform) => {
      if (supportedPlatforms?.codes && !supportedPlatforms.codes.includes(platform.code)) {
        memo.push(platform.title);
      }
      return memo;
    }, [])
    .toString();

  return unsuportedPlatforms ? (
    <Box paddingBottom={4}>
      <Alert
        type="inline"
        variant="info"
        title={`${i18n.t('entity.promoPhotos.notifications.unsuportedPlatforms')}:`}
        message={unsuportedPlatforms}
      />
    </Box>
  ) : null;
}
